import { HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { lastValueFrom } from "rxjs";
import { LoteService } from "src/app/core/services/lote.service";
import { TableAction } from "src/app/shared/components/table-paginator/table-paginator.component";
interface Item {
  id: string;
  id_user?: string;
  usuario: string;
  correo: string;
  estado: string;
}


@Component({
  selector: 'app-documentos-por-firmar',
  templateUrl: './documentos-por-firmar.component.html',
  styleUrls: ['./documentos-por-firmar.component.scss']
})
export class DocumentosPorFirmarComponent implements OnInit {


    fullData: Item[] = []; // Tu conjunto completo de datos
    currentItems: Item[] = []; // Los datos para la página actual


    lotesPorFirmar:any[]=  [];
    totalItemsLotesPorFirmar:any = 0;

    public formSearch: FormGroup;

    currentPage: number = 1;
    pageSize: number = 10; // Tamaño de página inicial
    totalItems: number = 0;
    spinner: boolean;

    
    tableHeaders = [      
      { key: 'titulo', label: 'Titulo' } , 
      { key: 'es_grupo', label: 'Grupal' },
      { key: 'firma_por_plantilla', label: 'Por plantilla' },
      { key: 'notificacion_firmantes', label: 'Notificación' } , 
      { key: 'total_documentos', label: 'Total documentos'  } , 
      { key: 'estado', label: 'Estado'  } , 
      { key: 'createdAt' , label: 'Fecha creación'  }
    ];

    // Definición de las acciones personalizadas
    customActions: TableAction[] = [];

    constructor(
      private loteService: LoteService , 
      private fb: FormBuilder,
      private router: Router
    ){}

    async ngOnInit() {
      this.formSearch = this.fb.group({
            search:  new FormControl('' , []) 
      });


      this.customActions = [
        {
          label: 'Editar',
          handler: (item: Item) => {           
           this.rederic('firmas/' + item.id  )   
          },
          icon: 'fa-solid fa-pen-to-square',
          colorClass: 'bg-orange',
        }
      ];

      await this.getPorFirmar();      
    }


    formatDate(dateStr: string): string {
      if (!dateStr) return '';

      const date = new Date(dateStr);

      return new Intl.DateTimeFormat('es-SV', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true, // false si quieres 24h
      }).format(date);
    }

    async search(){
      this.currentPage = 1;
      this.getPorFirmar();
    }


    async getPorFirmar(){
      
      
        let { search } = this.formSearch.value;

        let data = await lastValueFrom(this.loteService.getPorFirmar(this.currentPage, this.pageSize , {titulo: search}));
        const headers: HttpHeaders = data.headers;

        let dataResult = data.body;        
        this.currentItems  = dataResult.map((x:any) =>{
          return {
            id: x.loteCertificado.lote.id , 
            createdAt:  this.formatDate(x.loteCertificado.lote.createdAt), 
            es_grupo: (x.loteCertificado.lote.es_grupo ? 'Si' : 'No') , 
            titulo: x.loteCertificado.lote.titulo , 
            firma_por_plantilla: ( x.loteCertificado.lote.firma_por_plantilla ?  'Si' :  'No' ) , 
            notificacion_firmantes: ( x.loteCertificado.lote.notificacion_firmantes ?  'Si' :  'No'  ) , 
            total_documentos: x.loteCertificado.lote.total_documentos,
            usuario_email: x.certificado.usuario.email , 
            usuario_name: x.certificado.usuario.firstName+' '+ x.certificado.usuario.lastName,
            usuario_username: x.certificado.usuario.username , 
            estado_clase: x.loteCertificado.lote.estado.clase ,
            estado: x.loteCertificado.lote.estado.nombre
          }
        });

        this.totalItems = Number(headers.get('X-Total-Count'));
    }
    
   


    async onPageChange(newPage: number) {      
      this.currentPage = newPage;    
      await this.getPorFirmar();
    }
    
    async onPageSizeChange(newSize: number) {      
      this.pageSize = newSize;
      this.currentPage = 1; // Siempre vuelve a la primera página al cambiar el tamaño      
      await this.getPorFirmar();
    }

    
  rederic(modulo: string) {

    switch (modulo) {
      case 'firma':
        this.router.navigate(['firmas/admin-lotes']);
        break;
      case 'plantilla':
        this.router.navigate(['firmas/admin-plantillas']);
        break;
      case 'perfil':
        this.router.navigate(['perfil/perfil']);
        break;

      case 'firmantes':
        this.router.navigate(['firmas/firmantes']);        
        break;
      default:
           this.router.navigate([modulo]);        
        break;
    }
  }


}